import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './store'
import router from './router'
//import Router from 'vue-router'
import '@/icons' // icon
//import '@/permission' // permission control
import './permission' // permission control
// 引入 echarts
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

//Vue.use(Router)
Vue.use(ElementUI)

Vue.config.productionTip = true

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

